import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Datagrid from '../components/Datagrid';
import NewEntry from './components/NewEntry';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import AddIcon from '@material-ui/icons/AddBox';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import { MuiPickersUtilsProvider, KeyboardTimePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import Today from '@material-ui/icons/Today';
const tileHeight = 175;
const filterHeight = 55;

const styles = (theme) => ({
	dashboard: {
		height: `100%`,
		padding: `0 ${theme.spacing(5)}px`,
		width: '100%',
		position: 'relative',
	},
	dashboardTiles: {
		paddingTop: theme.spacing(1),
		padding: `0 ${theme.spacing(2)}px`,
		paddingRight: theme.spacing(1),
		position: 'relative',
	},
	dataGrid: {
		height: `calc(100% - ${tileHeight + filterHeight + theme.spacing(2)}px)`,
		padding: `0 ${theme.spacing(2)}px`,
		position: 'relative',
		minHeight: '50vh',
	},
	datagridPaper: {
		height: `100%`,
		padding: `0 ${theme.spacing(2)}px`,
		paddingBottom: theme.spacing(2),
		position: 'relative',
	},
	nodataFound: {
		fontStyle: 'italic',
		fontSize: 'inherit',
		color: '#7c8393',
		padding: '6px 0',
	},
	filterPanel: {
		height: `${filterHeight}px`,
		padding: `0 ${theme.spacing(2)}px`,
		position: 'relative',
		marginTop: theme.spacing(2),
	},
	groupIcon: {
		padding: `${theme.spacing(2)}px 0 !important`,
		color: '#ceebff !important',
	},
	button: {
		margin: theme.spacing(2),
	},
	addButton: {
		margin: theme.spacing(2),
		marginRight: 0,
	},
	modal: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: '2px solid #000',
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
	},
});

const numberColTemplate =
	'<div class="ag-cell-label-container" role="presentation">' +
	'  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
	'  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
	'    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
	'    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
	'    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
	'    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
	'    <span ref="eText" style="margin-left:auto;margin-right:2px;" class="ag-header-cell-text" role="columnheader"></span>' +
	'    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
	'  </div>' +
	'</div>';

function formatNumber(number) {
	return Math.floor(number)
		.toString()
		.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

class Dashboard extends Component {
	static propTypes = {
		loading: PropTypes.bool,
		portfolio: PropTypes.string,
		effectiveDate: PropTypes.object,
		headerActions: PropTypes.object,
	};

	static defaultProps = {
		loading: true,
	};

	constructor(props) {
		super(props);
		this.state = {
			openExit: false,
			showNewEntry: false,
			gridData: [
				{
					name: 'Amir',
					organization: 'Eagle',
					visit_person: 'Jefferson Dhanasingh',
					visit_purpose: 'Regarding hardware issue',
					visit_date: '23/12/2020',
					visit_in_time: '10 PM',
					visit_out_time: '10.30 PM',
					is_exit: 'Y',
				},
				{
					name: 'Jeff',
					organization: 'Eagle',
					visit_person: 'Amirthalingam Krishnamoorthy',
					visit_purpose: 'Visit',
					visit_date: '24/12/2020',
					visit_in_time: '10 AM',
					visit_out_time: '1 PM',
					is_exit: 'N',
				},
				{
					name: 'Sriganth',
					organization: 'Eagle',
					visit_person: 'EK',
					visit_purpose: 'General Visit',
					visit_date: '24/12/2020',
					visit_in_time: '11 AM',
					visit_out_time: '11.30 AM',
					is_exit: 'N',
				},
				{
					name: 'Amir',
					organization: 'Eagle',
					visit_person: 'Jefferson Dhanasingh',
					visit_purpose: 'Pending hardware issue',
					visit_date: '24/12/2020',
					visit_in_time: '12 PM',
					visit_out_time: '',
					is_exit: null,
				},
			],
			alertType: '',
			visit_out_time: new Date(),
			m_detail_id: 0,
			visit_date: '',
		};
	}

	componentDidUpdate() {
		const { visiterEntries } = this.props;
		if (this.gridApi) {
			this.gridApi.setRowData([]);
			this.gridApi.setRowData(visiterEntries);
			this.gridApi.refreshCells();
		}
	}

	onGridReady(params) {
		const { visiterEntries } = this.props;
		this.gridApi = params.api;
		this.columnApi = params.columnApi;
		this.setState({
			gridData: visiterEntries,
		});

		if (this.gridApi) {
			this.gridApi.sizeColumnsToFit();
			this.autoSizeAll();
			setTimeout(() => {
				this.gridApi.sizeColumnsToFit();
			}, 1000);
		}
	}

	autoSizeAll = (skipHeader) => {
		var allColumnIds = [];
		this.columnApi.getAllColumns().forEach(function (column) {
			if (column.colDef.headerName === '') allColumnIds.push(column.colId);
		});
		this.columnApi.autoSizeColumns(allColumnIds, skipHeader);
	};

	createImageSpan(imageMultiplier, isExit, m_detail_id, visit_date) {
		var resultElement = document.createElement('span');
		for (var i = 0; i < imageMultiplier; i++) {
			var image = document.createElement('img');
			//let image=new Image();
			image.src = isExit === 'Y' ? require('../assets/complete.png') : isExit === 'N' ? require('../assets/exiticon.png') : require('../assets/approve.png');
			image.style = 'width: 33px;height: 27px; padding: 0px 3px 0px 3px';
			image.loading = 'lazy';
			image.alt = image.src;
			if (isExit !== 'Y') {
				isExit === 'N'
					? image.addEventListener(
							'click',
							function () {
								this.handleOpen('E', m_detail_id, visit_date);
							}.bind(this)
					  )
					: image.addEventListener(
							'click',
							function () {
								this.handleOpen('A', m_detail_id, visit_date);
							}.bind(this)
					  );
			}
			//image.onclick = isExit !== 'Y' && this.handleOpen;
			image.style.cursor = isExit !== 'Y' && 'pointer';
			resultElement.appendChild(image);
		}
		return resultElement;
	}

	handleOpen = (alertType, m_detail_id, visit_date) => {
		//console.log(m_detail_id);

		this.setState({
			openExit: true,
			alertType: alertType,
			m_detail_id: m_detail_id,
			visit_date: visit_date,
		});
	};

	handleClose = () => {
		//console.log(this.state.visit_out_time);
		this.setState({
			openExit: false,
			alertType: '',
			m_detail_id: 0,
			visit_date: new Date(),
			visit_out_time: new Date(),
		});
	};

	handleExitClick = () => {
		const { newentryActions } = this.props;
		const m_detail_id = this.state.m_detail_id;
		const status = this.state.alertType === 'E' ? 'Y' : 'N';
		const endtime = this.state.alertType === 'E' ? this.GetTime(this.state.visit_out_time) : null;
		//console.log(endtime);
		newentryActions.updateVisiterEntries(m_detail_id, status, endtime);
		//newentryActions.requestVisiterEntries();
		this.setState({
			openExit: false,
			alertType: '',
			m_detail_id: 0,
		});
	};

	GetTime = (date) => {
		//let date = new Date();
		let hour = date.getHours();
		let TimeType = hour <= 11 ? 'AM' : 'PM';
		if (hour > 12) {
			hour = hour - 12;
		}
		if (hour == 0) {
			hour = 12;
		}
		let minutes = date.getMinutes();
		if (minutes < 10) {
			minutes = '0' + minutes.toString();
		}

		let fullTime = hour.toString() + ':' + minutes.toString() + ' ' + TimeType.toString();
		return fullTime;
	};

	exitIconRenderer(params) {
		return this.createImageSpan(1, params.value, params.data.id, params.data.visit_date);
	}

	getColumns() {
		return [
			{
				headerName: 'Visitor Name',
				field: 'first_name',
			},
			{
				headerName: 'To Visit',
				field: 'visit_person_long',
			},
			{
				headerName: 'Email',
				field: 'email_address',
			},
			{
				headerName: 'Mobile Number',
				field: 'mobile_number',
				maxWidth: 130,
			},
			{
				headerName: 'Visit Purpose',
				field: 'visit_purpose',
				maxWidth: 120,
			},
			{
				headerName: 'Reason',
				field: 'visit_note',
			},
			{
				headerName: 'Visit Date',
				field: 'visit_date',
				maxWidth: 130,
			},
			{
				headerName: 'In Time',
				field: 'visit_in_time',
				maxWidth: 120,
			},
			{
				headerName: 'Out Time',
				field: 'visit_out_time',
				maxWidth: 120,
			},
			{
				headerName: '',
				field: 'is_exit',
				cellRenderer: this.exitIconRenderer.bind(this),
				cellRendererParams: {
					rendererImage: 'is_exit', // Complementing the Cell Renderer parameters
				},
				maxWidth: 55,
			},
		];
	}

	handleAddClick = () => {
		this.setState({
			showNewEntry: true,
		});
		const { newentryActions } = this.props;
		newentryActions.setShowNewEntry(true);
	};

	handleBackClick = () => {
		this.setState({
			showNewEntry: false,
		});
		const { newentryActions } = this.props;
		newentryActions.setShowNewEntry(false);
	};

	handleRequestClick = (data) => {
		//let tempData = this.state.gridData;
		//tempData.push(data);
		this.setState({
			//gridData: tempData,
			showNewEntry: false,
		});
		const { newentryActions } = this.props;
		newentryActions.setShowNewEntry(false);
	};

	handleExitTimeChange = (date, time) => {
		//console.log(date);
		this.setState({
			visit_out_time: date,
		});
	};

	render() {
		const { classes, showNewEntry, visiterEntries } = this.props;
		const columns = this.getColumns();
		//console.log(visiterEntries);
		return (
			<Grid container className={classes.dashboard} direction='row' justify='flex-start' alignItems='stretch'>
				<Grid item xs={12} sm={12} md={12}>
					{/* {false? */}
					{showNewEntry ? (
						<NewEntry handleRequestClick={this.handleRequestClick} handleBackClick={this.handleBackClick} />
					) : (
						<div style={{ height: '85%' }}>
							<Box display='flex' justifyContent='flex-end'>
								<Button variant='contained' color='secondary' className={classes.addButton} startIcon={<AddIcon />} onClick={this.handleAddClick.bind(this)}>
									Register
								</Button>
							</Box>
							<Datagrid
								columnDefs={columns}
								refreshCells={true}
								rowData={visiterEntries}
								deltaRowDataMode={true}
								rowDataChangeDetectionStrategy='IdentityCheck'
								groupSuppressAutoColumn={true}
								groupHeaderHeight={50}
								defaultColDef={{ sortable: true, filter: true }}
								rememberGroupStateWhenNewData={true}
								onGridReady={this.onGridReady.bind(this)}
								overlayNoRowsTemplate='<span>No data to display</span>'
								getRowNodeId={(data) => data.instance}
								reactNext={true}
							/>
						</div>
					)}
				</Grid>
				<Modal
					aria-labelledby='transition-modal-title'
					aria-describedby='transition-modal-description'
					className={classes.modal}
					open={this.state.openExit}
					//onClose={this.handleClose.bind(this)}
					closeAfterTransition
					BackdropComponent={Backdrop}
					BackdropProps={{
						timeout: 500,
					}}
				>
					<Fade in={this.state.openExit}>
						<div className={classes.paper}>
							<Dialog open={true} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
								<DialogTitle id='alert-dialog-title'>{this.state.alertType === 'E' ? 'Are you sure you want to exit?' : 'Are you sure you want to approve the request?'}</DialogTitle>
								<DialogContent>
									<DialogContentText id='alert-dialog-description'>
										{this.state.alertType === 'E' && (
											<Grid container direction='column' spacing={1}>
												<Grid item align='center'>
													Visit Date : {this.state.visit_date}
												</Grid>
												<Grid item>
													<FormControl variant='outlined' className={classes.formControl} style={{ margin: 8 }} fullWidth>
														<MuiPickersUtilsProvider className={classes.zeroOutline} utils={DateFnsUtils}>
															<KeyboardTimePicker
																autoOk
																inputVariant='outlined'
																label={'Exit Time'}
																name={'Exit_time'}
																onChange={(date, value) => {
																	this.handleExitTimeChange(date, value);
																}}
																value={this.state.visit_out_time}
																keyboardIcon={<Today fontSize='small' />}
																fullWidth
																KeyboardButtonProps={{
																	'aria-label': 'change time',
																	size: 'small',
																}}
																InputProps={{
																	className: classes.datePickerInput,
																}}
																okLabel={<span style={{ color: 'white' }}>Ok</span>}
																cancelLabel={<span style={{ color: 'white' }}>CANCEL</span>}
																InputLabelProps={{
																	classes: {
																		root: classes.lable,
																		shrink: classes.labelShrink,
																	},
																}}
															></KeyboardTimePicker>
														</MuiPickersUtilsProvider>
													</FormControl>
												</Grid>
											</Grid>
										)}
									</DialogContentText>
								</DialogContent>
								<DialogActions>
									<Button onClick={this.handleExitClick.bind(this)} color='secondary'>
										Yes
									</Button>
									<Button onClick={this.handleClose.bind(this)} color='secondary' autoFocus>
										No
									</Button>
								</DialogActions>
							</Dialog>
						</div>
					</Fade>
				</Modal>
			</Grid>
		);
	}
}

export default withStyles(styles)(Dashboard);
